import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
    root: {
        width: 730,
        height: 704,
        background: "#fff",
        borderRadius: 10,
        padding: theme.spacing(3),
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    },
    header: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(2),
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    phone: {
        marginLeft: "auto",
        borderRadius: 20,
    },
    section: {
        marginBottom: theme.spacing(2),
    },
    outcome: {
        display: "flex",
        flexDirection: "column",
        marginBottom: theme.spacing(2),
    },
    notes: {
        width: "100%",
        height: 100,
        marginBottom: theme.spacing(2),
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: theme.spacing(2),
    },
    btn: {
        borderRadius: 8,
    },
}));

export default function CallDispositionSkeleton() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {/* Header */}
            <div className={classes.header}>
                <Skeleton variant="circle" width={40} height={40} className={classes.icon} />
                <Skeleton variant="text" width={200} height={30} />
                <Skeleton variant="rect" width={120} height={30} className={classes.phone} />
            </div>

            {/* Call Outcome */}
            <div className={classes.outcome}>
                <Skeleton variant="text" width={150} height={20} />
                <Skeleton variant="text" width={120} height={20} />
                <Skeleton variant="text" width={120} height={20} />
                <Skeleton variant="text" width={120} height={20} />
            </div>

            {/* Rate Call */}
            <div className={classes.section}>
                <Skeleton variant="rect" width={200} height={80} />
            </div>

            {/* Call Notes */}
            <div className={classes.section}>
                <Skeleton variant="text" width={150} height={20} />
                <Skeleton variant="rect" className={classes.notes} />
            </div>

            {/* Tag + Campaign */}
            <div className={classes.section} style={{ display: "flex", gap: "16px" }}>
                <Skeleton variant="rect" width={150} height={40} />
                <Skeleton variant="rect" width={150} height={40} />
            </div>

            {/* Footer Buttons */}
            <div className={classes.footer}>
                <Skeleton variant="rect" width={80} height={40} className={classes.btn} />
                <Skeleton variant="rect" width={80} height={40} className={classes.btn} />
            </div>
        </div>
    );
}